"use client";

import Link from "next/link";
import { useParams, useSearchParams } from "next/navigation";

type Props = {
  resultParam: { [key: string]: string | string[] | undefined };
  situationParam?: { [key: string]: string | string[] | undefined };
  isBat: boolean;
  children?: React.ReactNode;
};

function ResultLink({
  resultParam,
  situationParam,
  idParam,
  children,
  href,
}: Props & { idParam: { [key: string]: string | string[] | undefined }; href: string }) {
  const searchParams = useSearchParams();
  const situation = searchParams.get("situation") || undefined;

  const params = new URLSearchParams(
    JSON.parse(
      JSON.stringify({
        ...idParam,
        ...resultParam,
        ...situationParam,
        situation,
      })
    )
  );

  params.delete("role");
  return (
    <Link href={href + params.toString()} scroll={false} className="link">
      {children}
    </Link>
  );
}

export function ResultTeamLink(props: Props & { team: string }) {
  const dynamicParams = useParams();
  const { year } = dynamicParams;
  const idParam = props.isBat ? { bat_team: props.team } : { pit_team: props.team };
  return <ResultLink {...props} idParam={idParam} href={`/${year}/result?`} />;
}
export function ResultPlayerIdLink(props: Props) {
  const dynamicParams = useParams();
  const { year, id } = dynamicParams;
  const idParam = props.isBat ? { bat_id: id } : { pit_id: id };
  return <ResultLink {...props} idParam={idParam} href={`/${year}/result?`} />;
}
